/**
 * Display colour for a status dot. monday's own colour is used, except that "In progress" is always
 * blue (monday's orange reads like a warning) so the three states are easy to tell apart at a glance:
 * grey = not started, blue = in progress, green = done.
 */
export const IN_PROGRESS_BLUE = '#3b82f6';

export function statusColor(label: string | null, mondayColor?: string): string | undefined {
  if (label && /^in progress$/i.test(label.trim())) return IN_PROGRESS_BLUE;
  return mondayColor;
}
